// See docs/loadable-components.md for details regarding **.imports-X.** file extension & duplicate file structure.
import React from 'react';
import loadable from '@loadable/component';
import retry from '~/utils/retry';
import Loading from '~/shared/Loading';

const ModularSignUpContainer = loadable(() => retry(() => import('./ModularSignUpContainer')), {
  fallback: <Loading size="fullscreen" />,
  resolveComponent: module => module.ModularSignUpContainer,
});

export default ModularSignUpContainer;
